export const chartData = [
    {name: '6.00', uv: 500, pv: 1100, amt: 20},
    {name: '7.00', uv: 600, pv: 1600, amt: 21},
    {name: '8.00', uv: 500, pv: 1900, amt: 29},
    {name: '9.00', uv: 600, pv: 2100, amt: 20},
    {name: '10.00', uv: 700, pv: 2500, amt: 28},
    {name: '11.00', uv: 800, pv: 2200, amt: 20},
    {name: '12.00', uv: 700, pv: 2000, amt: 20},
    {name: '13.00', uv: 800, pv: 1900, amt: 20},
    {name: '14.00', uv: 850, pv: 1700, amt: 20},
    {name: '15.00', uv: 1000, pv: 2100, amt: 20},
];

export const chartData1 = [
    {name: 'Let A', uv: 20, pv: 40, amt: 20},
    {name: 'Let B', uv: 60, pv: 25, amt: 21},
    {name: 'Let C', uv: 20, pv: 98, amt: 29},
    {name: 'Let D', uv: 50, pv: 39, amt: 20},
    {name: 'Let E', uv: 30, pv: 60, amt: 28},
    {name: 'Let F', uv: 70, pv: 38, amt: 20},
    {name: 'Let G', uv: 56, pv: 43, amt: 20},
];
export const chartData2 = [
    {name: 'Let A', uv: 40, pv: 24, amt: 20},
    {name: 'Let B', uv: 10, pv: 13, amt: 21},
    {name: 'Let C', uv: 60, pv: 98, amt: 29},
    {name: 'Let D', uv: 27, pv: 15, amt: 20},
    {name: 'Let E', uv: 56, pv: 45, amt: 28},
    {name: 'Let F', uv: 23, pv: 56, amt: 20},
    {name: 'Let G', uv: 56, pv: 43, amt: 20},
];

export const expanseData = [
    {name: 'Jan', Income: 10, Expanse: 22},
    {name: 'Feb', Income: 5, Expanse: 20},
    {name: 'March', Income: 15, Expanse: 26},
    {name: 'April', Income: 13, Expanse: 22},
    {name: 'May', Income: 35, Expanse: 26},
    {name: 'June', Income: 25, Expanse: 20},
    {name: 'July', Income: 20, Expanse: 32},
    {name: 'Aug', Income: 25, Expanse: 35},
];

export const expanseData1 = [
    {name: 'Jan', Income: 32, Expanse: 3},
    {name: 'Feb', Income: 5, Expanse: 74},
    {name: 'March', Income: 100, Expanse: 2},
    {name: 'April', Income: 3, Expanse: 56},
    {name: 'May', Income: 126, Expanse: 15},
    {name: 'June', Income: 16, Expanse: 80},
    {name: 'July', Income: 140, Expanse: 2},
    {name: 'Aug', Income: 12, Expanse: 135},
    {name: 'Sep', Income: 95, Expanse: 5},
    {name: 'Oct', Income: 5, Expanse: 80},
    {name: 'Nov', Income: 126, Expanse: 20},
];

export const pieChartData = [
    {name: 'J', amt: 24},
    {name: 'F', amt: 18},
    {name: 'M', amt: 22},
    {name: 'A', amt: 17},
    {name: 'M', amt: 25},
    {name: 'J', amt: 12},
    {name: 'J', amt: 21},
];
export const post = [
    {
        image: 'http://via.placeholder.com/500x330',
        title: "Up unpacked friendly",
        description: "Contrary to popular belief, Lorem Ipsum is not simply random text."
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "It allowance prevailed",
        description: "It is a long established fact that a reader will be distracted"
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "Case read they must",
        description: "There are many variations of passages of Lorem Ipsum available"
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "Too carriage attended",
        description: "The standard chunk of Lorem Ipsum used since the 1500s"
    },
];

export const countryList1 = [
    {name: 'United State', flagCode: 'us', badge: '27', badgeColor: 'primary'},
    {name: 'France', flagCode: 'fr', badge: '32', badgeColor: 'teal'},
    {name: 'Germany', flagCode: 'gm', badge: '18', badgeColor: 'purple'},
    {name: 'Spain', flagCode: 'es', badge: '30', badgeColor: 'cyan'},
];
export const countryList2 = [
    {name: 'United Kingdom', flagCode: 'gm', badge: '27', badgeColor: 'secondary'},
    {name: 'Brazil', flagCode: 'br', badge: '32', badgeColor: 'success'},
    {name: 'India', flagCode: 'in', badge: '18', badgeColor: 'warning'},
    {name: 'Canada', flagCode: 'gm', badge: '30', badgeColor: 'danger'},
];
export const cardData = {
    img: 'http://via.placeholder.com/80x100',
    title: '23',
    subTitle: 'iDeas',
};
export const cardData1 = {
    img: 'http://via.placeholder.com/80x100',
    title: '387',
    subTitle: 'Docs',
};
export const cardData2 = {
    img: 'http://via.placeholder.com/80x100',
    title: 'New Customers',
    subTitle: '543',
};

export const cardData3 = {
    img: 'http://via.placeholder.com/80x100',
    title: 'Popular Products',
    subTitle: '22 new products',
};

export const data1 = [
    {name: 'Let A', uv: 40, pv: 24, amt: 20},
    {name: 'Let B', uv: 60, pv: 13, amt: 21},
    {name: 'Let C', uv: 30, pv: 98, amt: 29},
    {name: 'Let D', uv: 50, pv: 39, amt: 20},
    {name: 'Let E', uv: 20, pv: 48, amt: 28},
    {name: 'Let F', uv: 70, pv: 38, amt: 20},
    {name: 'Let G', uv: 40, pv: 43, amt: 20},
];

export const connections = [
    {
        id: 1,
        image: 'http://via.placeholder.com/256x256',
        name: "Domnic Brown",
        about: "@domnic.brown",
        detail: "Unfollow",
        color: "primary"
    },
    {
        id: 2,
        image: 'http://via.placeholder.com/256x256',
        name: "Stella Jhonson",
        about: "@stella.jhonson",
        detail: "Follow",
        color: "light"
    },
    {
        id: 3,
        image: 'http://via.placeholder.com/256x256',
        name: "John Smith",
        about: "@john.s",
        detail: "Unfollow",
        color: "primary"
    }
];

export const todoData = [
    {
        'id': 1,
        'notes': 'Create wireframes for Mouldifi',
        'selected': false,
    },
    {
        'id': 2,
        'notes': 'Design PSD files for Jambo',
        'selected': true,
    },
    {
        'id': 3,
        'notes': 'Bring the latest idea to the digital paper and\n' +
        'send this for the selection.',
        'selected': false,
    },
    {
        'id': 4,
        'notes': 'Deploy existing code to example.com',
        'selected': false,
    },
    {
        'id': 5,
        'notes': 'New logo design for Mouldifi project',
        'selected': true,
    },
    {
        'id': 6,
        'notes': 'Deploy existing code to example.com',
        'selected': false,
    }
];


// WEBPACK FOOTER //
// ./app/routes/dashboard/routes/data.js